var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrapper"},[_c('main',{staticClass:"login-wrapper__main"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/images/login-logo.png")},on:{"click":_vm.handleLogo}})]),_c('div',{staticClass:"content"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }